import { AlertCircle, Calendar, CalendarOff, CheckCircle, Video } from "lucide-react";
import { Skeleton } from "@workspace/web-ui/components/skeleton";

type EncounterStatusProps = {
    status: string, tag: string
}

// Add loading prop
type EncounterStatusPropsWithLoading = EncounterStatusProps & { loading?: boolean };

export const getEncounterStatus = ({ status, tag }: EncounterStatusProps) => {
    // if (appointment.status === "attended" && appointment?.recommendedTasks?.some(task => task.status === "pending")) {
    //     status = "actionNeeded"
    //     tag = "Action Needed"
    // }

    // Check if tag indicates "held" status for conditional styling
    const isHeld = tag?.toLowerCase() === "held";
    const heldColor = isHeld ? "bg-[#16A34A26] text-[#16A34A]" : "bg-[#DC262626] text-[#DC2626]";
    const heldIcon = isHeld ? <CheckCircle size={14} /> : <CalendarOff size={14} />;

    const statusMap = {
        "happening": { color: "bg-[#EBF0FB] text-[#4272DD]", icon: <Video size={14} />, text: tag, stats: "Ongoing" },
        "upcoming": { color: "bg-[#FFF6E7] text-[#FFAB1F]", icon: <Calendar size={14} />, text: tag, stats: "Upcoming" },
        "past": { color: "bg-[#F1F1F1] text-[#7F8493]", icon: <CalendarOff size={14} />, text: tag, stats: "Past" },
        "cancelled": { color: "bg-red-50 text-red-600", icon: <CalendarOff size={14} />, text: tag, stats: "Cancelled" },
        "completed": { color: heldColor, icon: heldIcon, text: tag || (isHeld ? "Held" : "Not Held"), stats: isHeld ? "Held" : "Not Held" },
        "attended": { color: heldColor, icon: heldIcon, text: tag || (isHeld ? "Held" : "Not Held"), stats: isHeld ? "Held" : "Not Held" },
        "actionNeeded": { color: "bg-[#EBF0FB] text-[#4272DD]", icon: <AlertCircle size={14} />, text: tag, stats: "actionNeeded" },
    };

    return statusMap[status as keyof typeof statusMap];
};

export const EncounterStatus = ({ status, tag, loading }: EncounterStatusPropsWithLoading) => {
    const { color, icon, text } = getEncounterStatus({ status, tag })

    return (
        <div className={`flex w-fit rounded-3xl items-center gap-2 px-2 py-1 ${color}`}>
            {icon && icon}
            {loading ? (
                <Skeleton className="h-4 w-20 rounded-full" />
            ) : (
                <span className="text-sm font-medium">{text}</span>
            )}
        </div>
    )
}
